import HeroSection from './components/HeroSection';
import LatestNews from './components/LatestNews';
import FeaturedWorks from './components/FeaturedWorks';
import QuickLinks from './components/QuickLinks';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function Home() {
  return (
    <>
      <SchemaOrg
        type="Organization"
        data={{
          name: '小野坂唯香中文粉丝资讯站',
          url: 'https://shiyaa.cn',
          description: '华语地区最全面的小野坂唯香中文资讯平台',
        }}
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: '小野坂唯香中文粉丝资讯站',
          url: 'https://shiyaa.cn',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://shiyaa.cn/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <main>
        <HeroSection />
        <LatestNews />
        <FeaturedWorks />
        <QuickLinks />
      </main>
    </>
  );
}